import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-promoBox__illustrationWrapper"
}
const _hoisted_2 = ["src", "width", "height", "alt"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 3,
  class: "o-buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["o-promoBox o-searchList__promoBox", [$options.modifierClass]])
  }, [
    ($props.promoBox.illustration.url)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
          _createElementVNode("img", {
            class: "o-promoBox__illustration",
            src: $options.illustrationSrc,
            width: $props.promoBox.illustration.umbracoWidth,
            height: $props.promoBox.illustration.umbracoHeight,
            alt: $props.promoBox.illustration.altText
          }, null, 8 /* PROPS */, _hoisted_2)
        ]))
      : _createCommentVNode("v-if", true),
    ($props.promoBox.heading)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: "o-promoBox__heading a-heading3",
          textContent: _toDisplayString($props.promoBox.heading)
        }, null, 8 /* PROPS */, _hoisted_3))
      : _createCommentVNode("v-if", true),
    ($props.promoBox.bodyText)
      ? (_openBlock(), _createElementBlock("p", {
          key: 2,
          class: "a-label",
          innerHTML: $options.convertedBodyText
        }, null, 8 /* PROPS */, _hoisted_4))
      : _createCommentVNode("v-if", true),
    ($options.showButton)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createVNode(_component_m_button, {
            icon: $options.buttonIcon,
            "icon-position": "right",
            url: $options.buttonUrl,
            theme: $options.buttonTheme,
            "ga-category": $props.promoBox.ctaButton.gaCategory,
            "ga-action": $props.promoBox.ctaButton.gaAction,
            "ga-label": $props.promoBox.ctaButton.gaLabel,
            "ga-indgangsmetode": $props.promoBox.ctaButton.gaIndgangsmetode,
            "button-text": $props.promoBox.ctaButton.link.name
          }, null, 8 /* PROPS */, ["icon", "url", "theme", "ga-category", "ga-action", "ga-label", "ga-indgangsmetode", "button-text"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}